module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0064.jpg?v=ff6f61c5";